"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vuex_1 = __importDefault(require("vuex"));
var views_1 = __importDefault(require("./config/views"));
var axios_1 = __importDefault(require("./axios"));
vue_1.default.use(vuex_1.default);
var Mutation;
(function (Mutation) {
    Mutation["authorize"] = "authorize";
    Mutation["setLoading"] = "setLoading";
    Mutation["updateSettings"] = "updateSettings";
})(Mutation = exports.Mutation || (exports.Mutation = {}));
var Action;
(function (Action) {
    Action["authorize"] = "authorize";
    Action["logout"] = "logout";
    Action["setCookies"] = "setCookies";
    Action["synchronizeAuthorizationStatus"] = "synchronizeAuthorizationStatus";
    Action["updateSettings"] = "updateSettings";
})(Action = exports.Action || (exports.Action = {}));
exports.default = new vuex_1.default.Store({
    state: {
        authorized: !!vue_1.default.$cookies.get("auth-token"),
        token: vue_1.default.$cookies.get("auth-token") || "",
        name: "",
        roles: vue_1.default.$cookies.get("auth-roles") || [],
        permissions: vue_1.default.$cookies.get("auth-permissions") || [],
        isLoading: false,
        loadingCounter: 0,
        settings: {},
        axios: axios_1.default(vue_1.default.$cookies.get("auth-token") || ""),
        errors: []
    },
    getters: {
        getSettings: function (state) { return state.settings; }
    },
    mutations: (_a = {},
        _a[Mutation.authorize] = function (state, _a) {
            var authorized = _a.authorized, token = _a.token, name = _a.name, roles = _a.roles, permissions = _a.permissions;
            state.authorized = typeof authorized !== "undefined" ? authorized : state.authorized;
            state.token = typeof token !== "undefined" ? token : state.token;
            state.name = name || state.name;
            state.roles = roles || state.roles;
            state.permissions = permissions || state.permissions;
            state.axios = axios_1.default(token || "");
        },
        _a[Mutation.setLoading] = function (state, isLoading) {
            if (isLoading === void 0) { isLoading = true; }
            state.loadingCounter = isLoading
                ? state.loadingCounter + 1
                : Math.max(state.loadingCounter - 1, 0);
            state.isLoading = !!state.loadingCounter;
        },
        _a[Mutation.updateSettings] = function (state, settings) {
            state.settings = settings ? settings : state.settings;
        },
        _a),
    actions: (_b = {},
        _b[Action.authorize] = function (_a, _b) {
            var commit = _a.commit, dispatch = _a.dispatch, state = _a.state;
            var vue = _b.vue, email = _b.email, password = _b.password;
            commit(Mutation.setLoading);
            state.axios.post("/api/login", { email: email, password: password }).then(function (response) {
                var _a = response.data, token = _a.token, name = _a.name, roles = _a.roles, permissions = _a.permissions;
                commit(Mutation.authorize, {
                    authorized: true,
                    token: token,
                    name: name,
                    roles: roles,
                    permissions: permissions
                });
                dispatch(Action.setCookies, {
                    token: token,
                    name: name,
                    roles: roles,
                    permissions: permissions
                });
                vue.$router.push(views_1.default.Scouts.path);
                vue.$nextTick(function () {
                    vue.$notification("success", vue.$lang("Zalogowano do Platformy!"));
                });
            }).catch(function (error) {
                vue.$notification("danger", error.response.data);
            }).finally(function () {
                commit(Mutation.setLoading, false);
            });
        },
        _b[Action.logout] = function (_a) {
            var commit = _a.commit, dispatch = _a.dispatch;
            dispatch(Action.setCookies, {});
            commit(Mutation.authorize, {
                authorized: false,
                token: "",
                name: "",
                roles: [],
                permissions: []
            });
        },
        _b[Action.setCookies] = function (_a, _b) {
            var token = _b.token, name = _b.name, roles = _b.roles, permissions = _b.permissions;
            if (token) {
                vue_1.default.$cookies.set("auth-token", token);
            }
            else {
                vue_1.default.$cookies.remove("auth-token");
            }
            if (name) {
                vue_1.default.$cookies.set("auth-name", name);
            }
            else {
                vue_1.default.$cookies.remove("auth-name");
            }
            if (roles) {
                vue_1.default.$cookies.set("auth-roles", roles);
            }
            else {
                vue_1.default.$cookies.remove("auth-roles");
            }
            if (permissions) {
                vue_1.default.$cookies.set("auth-permissions", permissions);
            }
            else {
                vue_1.default.$cookies.remove("auth-permissions");
            }
        },
        _b[Action.synchronizeAuthorizationStatus] = function (_a, _b) {
            var commit = _a.commit, dispatch = _a.dispatch, state = _a.state;
            var vue = _b.vue, settings = _b.settings;
            if (state.authorized) {
                state.axios.get("/api/user/status").then(function (response) {
                    var _a = response.data, name = _a.name, roles = _a.roles, permissions = _a.permissions;
                    commit(Mutation.authorize, {
                        authorized: true,
                        token: state.token,
                        name: name,
                        roles: roles,
                        permissions: permissions
                    });
                    commit(Mutation.updateSettings, settings);
                    dispatch(Action.setCookies, {
                        token: state.token,
                        name: name,
                        roles: roles,
                        permissions: permissions
                    });
                }).catch(function (error) {
                    vue.$notification("danger", error.response.data ? error.response.data : vue.$lang("Sesja użytkownika wygasła"));
                    dispatch(Action.logout);
                });
            }
        },
        _b[Action.updateSettings] = function (_a, _b) {
            var commit = _a.commit, dispatch = _a.dispatch, state = _a.state;
            var settings = _b.settings;
            commit(Mutation.updateSettings, settings);
        },
        _b)
});
